<template>
  <div>
    <borFrame :title="'分来源推送情况'" :iconShow="true" @iconClick="echartsShow = !echartsShow">
      <div v-if="list.length > 0">
        <div v-show="echartsShow" class="borFrame_echart" ref="borFrame_echart" id="borFrame_echart">
        </div>
        <div v-show="!echartsShow" class="borFrame_content">
          <TableDemo :columns="columns" :data="list"></TableDemo>
        </div>
        <p class="borFrame_content_more">
          从当日分来源推送情况来看，系统预警下发信息最多的是【{{ maxName }}】,共{{ maxNum }}条，较于昨日，系统预警下发最多的是【{{ maxName2 }}】，共{{ maxNum2 }}条。
        <div class="borFrame_content_more_btn" @click="detailsClick">
          查看详情 >
        </div>
        </p>
      </div>
    </borFrame>
  </div>
</template>
<script>
import borFrame from "@/components/frame";
import TableDemo from "@/components/table";
import * as echarts from 'echarts';
import moment from 'moment';
import { warningSource } from '@/api/index'
export default {
  name: 'Push',
  components: {
    borFrame,
    TableDemo
  },
  data() {
    return {
      echartsShow: true,
      maxName: '',
      maxNum: 0,
      maxName2: '',
      maxNum2: 0,
      columns: [
        {
          prop: 'name',
          label: '来源',
          width: '50%',
          align: 'center',
          'min-width': '0.6rem'
        },
        {
          prop: 'value',
          label: '预警数量',
          align: 'center',
          width: '50%',
          'min-width': '0.6rem'
        },
      ],
      list: [],
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    moment,
    initEchart(val1) {
      let myChart = echarts.init(this.$refs.borFrame_echart);
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:({d}%)',
        },
        legend: [
          {
            bottom: '0',
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle',
            textStyle: {
              color: '#4E5969',
              fontSize: 12,
              padding: [0, 0, 0, 0],
            },
            formatter: function (name) {  //图例后添加数值
              let data = option.series[0].data;
              let tarValue;
              for (let i = 0; i < data.length; i++) {
                if (data[i].name === name) {
                  tarValue = data[i].value;
                }
              }
              return name + ": " + tarValue;
            }

          }],
        grid: {
          top: '20%', // 图例距离容器上边缘的距离为20px
          left: '50%', // 图例距离容器左边缘的距离为40px
        },
        title: {
          text: `{a| 分来源 }`,
          textStyle: {
            rich: {
              a: {
                fontSize: 12,
                color: '#1D2129',
              },
            },
          },
          subtext: `{a|推送}`,
          subtextStyle: {
            rich: {
              a: {
                fontSize: 12,
                color: '#1D2129',
                padding: [0, 0, 0, 7],
              },
            },
          },
          x: '42%',
          y: '35%',
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['50%', '40%'],
            color: [
              '#86DF6C',
              '#249EFF',
              '#0E42D2',
              '#846BCE',
              '#21CCFF',
            ],
            label: {
              position: 'outside',
              show: true,
              color: '#4E5969',
              fontSize: 12,
              formatter: function (params) {
                if (params.name !== '') {
                  return params.percent + '%';
                }
              },
            },
            labelLine: {
              show: true,
              length2: 10,
              length: 5,
            },
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: '#fff',
              },
            },
            data: val1,
          },
        ],
      }
      myChart.setOption(option);
    },
    getList() {
      const time = this.$route.query.time;
      const formatTime = moment(time, 'YYYY年M月D日').format('YYYY-MM-DD');
      const startTime = moment(formatTime).startOf('day').valueOf();
      const endTime = moment(formatTime).endOf('day').valueOf();
      let data = {
        endTime: endTime,
        startTime: startTime,
        openId: localStorage.getItem('id')
      }
      let arr = [];
      warningSource(data).then(res => {
        for (let i = 0; i < res.sourceStatistics.length; i++) {
          arr.push({
            value: res.sourceStatistics[i].num,
            name: res.sourceStatistics[i].key
          })
        }
        // 查找res.sourceStatistics数组对象中最大的value值索引
        let maxIndex = 0;
        for (let i = 1; i < arr.length; i++) {
          if (arr[i].value > arr[maxIndex].value) {
            maxIndex = i;
          }
        }
        this.maxName = arr[maxIndex].name;
        this.maxNum = arr[maxIndex].value;
        this.maxName2 = res.yesterdaySourceName
        this.maxNum2 = res.yesterdaySourceNum
        this.list = arr;
        this.$nextTick(() => {
          this.initEchart(arr);
        })
      })
    },
    detailsClick() {
      this.$router.push({
        path: '/details',
        query: {
          time: this.$route.query.time
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.borFrame_echart {
  width: 100%;
  height: 4rem;


}

.borFrame_content_more {
  background: #f8f8f8;
  letter-spacing: 1px;
  line-height: 1.5;
  margin-top: .1rem;

  &_btn {
    margin-top: .1rem;
    color: #9a9494;
    font-size: .14rem;
    text-align: right;
  }
}
</style>